<template>
  <introduce @btn-update="handleUpdate" />
</template>
<script>
import introduce from "../../components/base/introduce-page";
export default {
  components: { introduce },
  mounted() {
    this.handleUpdate();
  },
  methods: {
    handleUpdate() {
      //处理个性化样式
      // 为后续个性化备用
      // this.$nextTick(x => {
      //   let dom = document.querySelector("span[class~='result-btn-download']");
      //   if (dom) {
      //     dom.classList.add("result-btn-mx");
      //   }
      // });
    }
  }
};
</script>

<style lang="scss">
</style>


